import React from "react";
import { CheckCheck } from "lucide-react";

const CONVERSATIONS = [
  {
    name: "Rui Costa",
    location: "Lisboa",
    time: "09:42",
    messages: [
      { text: "Kawan, tudo bem?", me: true },
      { text: "Acabei de terminar o curso e fiz o exame SIGO. Passei 😁", me: true },
      { text: "Aquelas aulas dos sinais manuais foram OURO no exame 🙏", me: true },
      { text: "Muito bom Rui!! Parabéns 👏 agora é só subir 💪", me: false },
      { text: "Já tenho entrevista na 2ª feira numa construtora em Alverca", me: true },
    ],
  },
  {
    name: "Miguel Santos",
    location: "Porto",
    time: "14:18",
    messages: [
      {
        text: "Comecei o curso há 3 semanas. Trabalho das 9h às 18h mas faço as aulas à noite. Top.",
        me: true,
      },
      { text: "Fixe! Aguenta que vale a pena.", me: false },
      { text: "Já estou no módulo 6. Cartão e Certificado SIGO chegaram no meu endereço 🔥", me: true },
      {
        text: "Obrigado pelo material PDF com as 10 perguntas. Foi exatamente o que caiu.",
        me: true,
      },
    ],
  },
  {
    name: "Jorge Pinto",
    location: "Braga",
    time: "20:03",
    messages: [
      { text: "Olá Kawan. Trabalhava em armazém, sem futuro. 40 anos, sem formação.", me: true },
      { text: "Está nunca é tarde. Eu comecei aos 25. O cartão é o mais importante.", me: false },
      { text: "Já estou a ganhar 2.400€. Mudou-me a vida. Obrigado.", me: true },
      { text: "Recomendo a toda a gente que está à procura de virar a página.", me: true },
    ],
  },
];

export default function Testimonials() {
  return (
    <section
      className="py-24 sm:py-32 bg-[#0A0A0A] border-b border-white/10"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
            Depoimentos reais
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            QUEM JÁ ESTÁ <br />
            <span className="text-yellow-400">NO COMANDO.</span>
          </h2>
          <p className="mt-5 text-zinc-400 max-w-xl">
            Mensagens de alunos reais ao Kawan. Identidades preservadas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {CONVERSATIONS.map((c, i) => (
            <WhatsAppChat key={c.name} conv={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function WhatsAppChat({ conv, index }) {
  return (
    <figure
      data-testid={`testimonial-${index}`}
      className="bg-[#0b141a] border border-white/10 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.8)] overflow-hidden flex flex-col"
    >
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3 bg-[#202c33] border-b border-black/30">
        <div className="w-10 h-10 bg-yellow-400 text-black font-display text-base flex items-center justify-center rounded-full">
          {conv.name
            .split(" ")
            .map((n) => n[0])
            .slice(0, 2)
            .join("")}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-white font-semibold text-sm truncate">{conv.name}</div>
          <div className="text-[11px] text-[#8696a0] truncate">{conv.location} · online</div>
        </div>
        <div className="text-[10px] text-[#8696a0]">{conv.time}</div>
      </div>

      {/* Messages */}
      <div
        className="flex-1 p-4 space-y-2"
        style={{
          backgroundImage:
            "linear-gradient(rgba(11,20,26,0.92), rgba(11,20,26,0.92)), repeating-linear-gradient(45deg, #0b141a, #0b141a 2px, #0a1217 2px, #0a1217 4px)",
        }}
      >
        {conv.messages.map((m, i) => (
          <div
            key={i}
            className={`flex ${m.me ? "justify-start" : "justify-end"}`}
          >
            <div
              className={`max-w-[85%] px-3 py-2 text-[13px] leading-relaxed ${
                m.me
                  ? "bg-[#202c33] text-white rounded-r-xl rounded-bl-xl"
                  : "bg-[#005c4b] text-white rounded-l-xl rounded-br-xl"
              }`}
            >
              {m.text}
              {!m.me && (
                <span className="inline-flex items-center gap-0.5 ml-2 text-[10px] text-[#53bdeb]">
                  <CheckCheck className="w-3 h-3" />
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <figcaption className="px-4 py-3 bg-[#111b21] border-t border-black/30 text-center">
        <span className="text-[11px] uppercase tracking-widest text-[#8696a0]">
          Mensagem real · verificada
        </span>
      </figcaption>
    </figure>
  );
}
